import { Typography } from '@mui/material'
import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { StatsContext } from '../../Contexts'
import { Property } from '../Property'

const TotalMintedProperty: React.FC = () => {
  const { geotokensMinted } = useContext(StatsContext)
  const navigate = useNavigate()
  const onView = () => {
    navigate('/auctions/minted')
  }
  return (
    <Property actions={[{ name: 'View', onClick: onView }]} title="Total Minted" value={geotokensMinted}>
      <Typography variant="caption">{geotokensMinted}</Typography>
    </Property>
  )
}

export default TotalMintedProperty
